import { SxProps } from "@mui/material";

export const sxTempContainer: SxProps = { 
  padding: '8px 16px 8px 16px', 
  width: '178px', 
  display: 'flex', 
  gap: '15px', 
  alignItems: 'center'
}

export const sxInfoTextContainer: SxProps = { 
  maxWidth: '700px', 
  display: 'flex', 
  flexDirection: 'column', 
  gap: '10px' 
}

export const sxInfoTempContainer: SxProps = {
  display: 'flex',
  gap: '16px',
  '@media(max-width: 799px)': {
    flexDirection: 'column'
  }
}

export const sxInfoEstadoEmocionalContainer: SxProps = { 
  width: '20%', 
  display: 'flex', 
  flexDirection: 'column', 
  gap: '10px' 
}

export const sxTermsOfUseModalTitle: SxProps = {
  color: '#383838',
  fontFamily: 'UnimedSans-Bold',
  fontSize: '20px',
  fontWeight: '700',
}

export const sxTermsOfUseModal: SxProps = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  maxWidth: '650px',
  width: '85%',
  bgcolor: '#fff',
  borderRadius: '16px',
  border: 'none',
  boxShadow: '0px 4px 100px 0px rgba(56, 56, 56, 0.20)',
  padding: '32px',
  gap: '24px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center'
}

export const sxAgendamentoCard: SxProps = {
  padding: '30px', 
  display: 'flex', 
  gap: '20px', 
  width: '100%',
  '@media(max-width: 799px)': {
    flexDirection: 'column'
  }
}

